module.exports = __webpack_public_path__ + "img/Candidat.da4fdefb.svg";